import React, { useCallback, useMemo, useState } from 'react';
import styles from './index.module.scss';
import VibeScreen from './components/vibe-screen';
import { SohoVibeContext } from './context';

const SohoVibeFlowWrapper = ({
  children,
  enabled = true,
  onComplete = null,
  renderReviewScreen = null
}) => {
  const [flowCompleted, setFlowCompleted] = useState(() => !enabled);
  const [isReviewRequested, setIsReviewRequested] = useState(false);

  const completeFlow = useCallback(
    ({ toReview = false } = {}) => {
      if (onComplete) onComplete();

      if (toReview && renderReviewScreen) {
        setIsReviewRequested(true);
        return;
      }

      setIsReviewRequested(false);
      setFlowCompleted(true);
    },
    [onComplete, renderReviewScreen]
  );

  const exitReviewScreen = useCallback(() => {
    setIsReviewRequested(false);
    setFlowCompleted(true);
  }, []);

  const backToVibeScreen = useCallback(() => setIsReviewRequested(false), []);

  const contextValue = useMemo(
    () => ({ isReviewRequested }),
    [isReviewRequested]
  );

  if (flowCompleted) {
    return (
      <SohoVibeContext.Provider value={contextValue}>
        {children}
      </SohoVibeContext.Provider>
    );
  }

  return (
    <>
      <VibeScreen onComplete={completeFlow} />
      {isReviewRequested && renderReviewScreen && (
        <div className={styles.reviewOverlay}>
          {renderReviewScreen(exitReviewScreen, backToVibeScreen)}
        </div>
      )}
    </>
  );
};

export default SohoVibeFlowWrapper;
